import { render, staticRenderFns } from "./PageEditorPagePanel.vue?vue&type=template&id=b975f8b2&scoped=true"
import script from "./PageEditorPagePanel.vue?vue&type=script&lang=js"
export * from "./PageEditorPagePanel.vue?vue&type=script&lang=js"
import style0 from "./PageEditorPagePanel.vue?vue&type=style&index=0&id=b975f8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b975f8b2",
  null
  
)

export default component.exports